import Cookies, { CookieAttributes } from "js-cookie";

export const ParcisionCookiesBase = {
  get: (name: string) => {
    return Cookies.get(name);
  },
  set: (name: string, value: string, attributes: CookieAttributes) => {
    Cookies.set(name, value, attributes);
  },
  remove: (name: string, attributes: CookieAttributes) => {
    Cookies.remove(name, attributes);
  },
  all: () => {
    return Cookies.get();
  },
  /*
  isTokenExpired: (value: string) => {

    // let expired_web3 = true;
    // const allCookies = ParcisionCookiesBase.all();
    //  check if auth0 expired or pera disconnected
    // if ("web3_expireTime" in allCookies) {
    //  expired_web3 = new Date(Number(ParcisionCookiesBase.get("web3_expireTime"))) < new Date();
    //}

    // IF PERA THEN IS IT CONNECT?

    return true;
  },
  */
};

const ParcisionCookieFactory = {
  createInstance: (attributes: CookieAttributes) => {
    return {
      get: (name: string) => {
        return ParcisionCookiesBase.get(name);
      },
      set(name: string, value: string) {
        ParcisionCookiesBase.set(name, value, attributes);
      },
      remove(name: string) {
        ParcisionCookiesBase.remove(name, attributes);
      },
      check(name: string) {
        return name in ParcisionCookiesBase.all();
      },
      all() {
        return ParcisionCookiesBase.all();
      },
      /*
      async isTokenExpiredWithCallback<OnExpiredReturnType, OnNotExpiredReturnType>(
        value: string,
        onExpired: () => null | Promise<null | OnExpiredReturnType>,
        onNotExpired: () => null | Promise<null | OnNotExpiredReturnType>
      ) {
        const isExpired = ParcisionCookiesBase.isTokenExpired(value);
        if (isExpired) {
          if (onExpired.constructor.name === "AsyncFunction") {
            return onExpired();
          }
          return Promise.resolve(onExpired());
        }
        if (onNotExpired.constructor.name === "AsyncFunction") {
          return onNotExpired();
        }
        return Promise.resolve(onNotExpired());
      },
      isTokenExpired() {
        return ParcisionCookiesBase.isTokenExpired("ABC123");
      },
      */
    };
  },
};

const ParcisionCookies = ParcisionCookieFactory.createInstance({
  path: "/",
  secure: true,
  httpOnly: false,
  sameSite: "strict",
});

export default ParcisionCookies;
